export default {
  setCountryList (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setCountryList", payload)
      resolve()
    })
  }
}
